import React, { useState } from 'react';
import { Eye, EyeSlash } from 'react-bootstrap-icons';
import { Input, Button } from 'reactstrap';
import { useTranslation } from "react-i18next";
import "./TextFieldPassword.css"

const TextFieldPassword = (props) => {
    const { id, name, value, style, placeholder, type, disabled, maxLength, min, onChange, title, required, onClick, requiredText } = props
    const [showPassword, setShowPassword] = useState(false);
    const { t } = useTranslation();
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const handleChange = (e) => {
        onChange && onChange(e)
    }

    const handleClick = (e) => {
        onClick && onClick(e)
    }


    return (
        <div>
            <div style={{ position: 'relative' }}>
                <Input
                    id={id}
                    name={name}
                    label={name}
                    value={value}
                    style={style}
                    placeholder={placeholder}
                    type={type}
                    disabled={disabled}
                    maxLength={maxLength}
                    min={min}
                    onChange={handleChange}
                    title={title}
                    required={required}
                    onClick={handleClick}
                    className={showPassword ? 'text' : 'mainPassword'}
                />
                <Button
                    style={{
                        position: 'absolute',
                        top: '50%',
                        right: '10px',
                        transform: 'translateY(-50%)',
                        backgroundColor: 'transparent',
                        border: 'none',
                        color: 'black'
                    }}
                    onClick={togglePasswordVisibility}
                >
                    {showPassword ? <Eye /> : <EyeSlash />}
                </Button>
            </div>
        </div>
    );
};

export default TextFieldPassword